// src/store/auth/selectors.js

import { createSelector } from 'reselect';

const selectAuth = (state) => state.auth;

export const selectUserApplications = createSelector(
    [selectAuth],
    (auth) => auth.applications
);

export const selectAppPermissions = createSelector(
    [selectUserApplications, (_state, appName) => appName],
    (applications, appName) =>
        applications.find(app => app.app_name === appName) || {}
);
